module.exports = __webpack_public_path__ + "img/photo-team11.74abdc20.png";